import { http } from '@/api/core/request';
import { ApiUrls } from '@/api/endpoints/apiUrls';
import {
  SupportedLanguage,
  TranslateParams,
  TranslateResult
} from '@/api/types';

/**
 * 翻译服务
 * 处理AI翻译相关的API请求
 */
export class TranslationService {
  /**
   * 获取支持的语言列表
   * @returns 支持的语言列表
   */
  static async getSupportedLanguages(): Promise<SupportedLanguage[]> {
    return http.get<SupportedLanguage[]>(ApiUrls.TRANSLATION.SUPPORTED_LANGUAGES);
  }

  /**
   * 翻译文本
   * @param params 翻译参数
   * @returns 翻译结果
   */
  static async translate(params: TranslateParams): Promise<TranslateResult> {
    return http.post<TranslateResult>(ApiUrls.TRANSLATION.TRANSLATE, params);
  }
}
